<template lang="pug">
  v-dialog(v-model="openBusinessDialog" max-width="700" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    TimeBlockDialog(
      v-if="addNewTimeBlockDialog"
      :addNewTimeBlockDialog="addNewTimeBlockDialog"
      :selectedTimeBlockColection="timeBlockCollection"
      :selectedTimeBlock="selectedTimeBlock"
      :businessToEdit="businessToEdit"
      @close="onCloseTimeBlockDialog"
      @saved="savedData"
      @updated="updatedData"
      @deleted="deletedData")
    v-card
      v-card-title.headline(v-if="!businessToEdit") {{ $t('businessPage.addBusinessDialogTitle') }}
      v-card-title.headline(v-else) {{ $t('businessPage.editBusinessDialogTitle') }}
      v-tabs(
        v-model="tab"
        show-arrows
        next-icon="fas fa-arrow-right"
        prev-icon="fas fa-arrow-left")
        v-tab {{ $t('businessPage.propertieLabel') }}
        v-tab(:disabled="!this.businessToEdit") {{ $t('businessPage.timeBlock') }}
      v-card-text
        v-tabs-items(v-model="tab" touchless)
          v-tab-item
            v-form(v-model="formIsValid" ref="form" :disabled="saveInProgress" lazy-validation)
              v-row
                v-col(cols="12")
                  v-text-field(v-model="businessName" :rules="businessNameRules" autofocus :validate-on-blur="validateOnBlur"
                  :label="$t('businessPage.businessNameLabel')" outlined)
          v-tab-item
            v-card-text.pa-0(v-if="$vuetify.breakpoint.mdAndUp")
              v-toolbar.elevation-0(v-if="this.$vuetify.breakpoint.mdAndUp" )
                v-btn.ml-2(color="primary" @click="addNewTimeBlock" ) {{ $t('businessPage.addNewTimeBlockLabel') }}
              v-fab-transition(v-else)
                v-btn.mb-16(  @click="addNewTimeBlock" color="pink"
                  right bottom fixed fab dark)
                  v-icon fas fa-plus
              v-list(dense)
                draggable(
                  ghost-class="grey"
                  handle=".handle"
                  v-model="timeBlockCollection"
                  @change="onDraggableChange"
                  :disabled="saveInProgress"
                  )
                  template
                    v-list-item.subtitle-1.mb-1.listItem(v-for="(item,idx) in timeBlockCollection" :key="idx" )
                      v-icon.pr-4.dragStyle(small class="handle") fal fa-bars
                      v-list-item-content.listItem(@click="showDetailDialog(item)") {{idx+1}}. {{item.title}}
            v-card-text.pa-0(v-else )
              v-toolbar.elevation-0(v-if="this.$vuetify.breakpoint.mdAndUp" )
                v-btn.ml-2(color="primary" @click="addNewTimeBlock" ) {{ $t('businessPage.addNewTimeBlockLabel') }}
              v-fab-transition(v-else)
                v-btn.mb-16(  @click="addNewTimeBlock" color="pink"
                  right bottom fixed fab dark)
                  v-icon fas fa-plus
              v-list(dense)
                draggable.dragStyle(
                  ghost-class="grey"
                  handle=".handle"
                  v-model="timeBlockCollection"
                  @change="onDraggableChange"
                  :disabled="saveInProgress")
                  template(v-for="(item,idx) in timeBlockCollection")
                    v-list-item.subtitle-1.mb-1.listItem
                      v-icon.pr-4.dragStyle(small class="handle") fal fa-bars
                      v-list-item-content.listItem(@click="showDetailDialog(item)") {{idx+1}}. {{item.title}}
      v-divider
      v-card-actions.justify-end
        v-btn(@click="onCloseButtonClick" text :disabled="saveInProgress") {{ $t('buttons.closeButtonLabel') }}
        v-btn( color="primary" @click="onSaveButtonClick" :loading="saveInProgress" :disabled="saveInProgress || !formIsValid") {{ $t('buttons.saveButtonLabel') }}

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import BusinessModel from "@/model/menu/BusinessModel";
import {Action} from "vuex-class";
import {AddNewBusinessPayload, UpdateBusinessPayload, UpdateTimeBlockPayload} from "@/types/payload";
import {
  FETCH_TIME_BLOCK_COLLECTION, FETCH_TIME_BLOCK_COLLECTION_BY_ID,
  SAVE_NEW_BUSINESS,
  UPDATE_BUSINESS, UPDATE_TIME_BLOCK,
} from "@/store/action-types";
import i18n from "@/i18n";
import draggable from "vuedraggable";
import BusinessTimeBlockCollection from "@/model/business/BusinessTimeBlockCollection";
import TimeBlockDialog from "@/components/business/TimeBlockDialog.vue";

@Component({
  components: {
    draggable,
    TimeBlockDialog
  }
})
export default class AddOrEditBusinessDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({type: Boolean, default: false}) openBusinessDialog!: boolean
  @Prop({type: Object as () => BusinessModel}) businessToEdit!: BusinessModel
  @Action(SAVE_NEW_BUSINESS) saveNewBusiness!: { (payload: AddNewBusinessPayload): Promise<BusinessModel> }
  @Action(UPDATE_BUSINESS) updateBusiness!: { (payload: UpdateBusinessPayload): Promise<BusinessModel> }
  @Action(FETCH_TIME_BLOCK_COLLECTION) fetchTimeBlockCollection!: ({ (payload: any): Promise<BusinessTimeBlockCollection[]> })
  @Action(UPDATE_TIME_BLOCK) updateSelectedTimeBlock!: { (updatePayload: UpdateTimeBlockPayload): Promise<any> }

  private businessName: string = ""
  private saveInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private businessAction: string = ""
  private formIsValid: boolean = true
  private businessNameRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('businessPage.businessNameValidationText').toString()
  ]
  private selectedTimeBlock: BusinessTimeBlockCollection | null = null
  private timeBlockCollection: BusinessTimeBlockCollection[] | null = null
  private addNewTimeBlockDialog: boolean = false
  private tab: number | null = null
  private validateOnBlur: boolean = true
  private filteredTimeBlock: any []| null = []

  /*getTimeBlockList () {
    if(this.businessToEdit.id && this.timeBlockCollection) {
      console.log(this.timeBlockCollection.filter((item: any) => item.business.id === this.businessToEdit.id))
      return this.filteredTimeBlock = this.timeBlockCollection.filter((item: any) => item.business.id === this.businessToEdit.id)
    } else {
      return []
    }
  }*/

  @Watch('businessName')
  onBusinessName(newVal: string): void {
    if(this.validateOnBlur) {
      this.validateOnBlur = false
    }
  }

  showDetailDialog (item:any) {
    this.selectedTimeBlock = item
    this.addNewTimeBlockDialog = true
  }

  savedData () {
    this.showSnackBar = true
    this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
    this.snackBarColor = 'success'
    this.fetchData()
  }

  updatedData () {
    this.showSnackBar = true
    this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
    this.snackBarColor = 'success'
    this.fetchData()
  }

  deletedData () {
    this.showSnackBar = true
    this.snackBarColor = 'success'
    this.snackBarMessage = this.$t('settingsPage.deleted').toString()
    this.fetchData()
  }

  onSaveButtonClick(): void {
    if (!this.businessToEdit) {
      this.saveBusiness()
    } else if (this.businessToEdit) {
      this.saveBusiness()
    }
  }

  async updateTimeBlock(payload: UpdateTimeBlockPayload):Promise<void>{
    try {
      this.saveInProgress = true
      await this.updateSelectedTimeBlock(payload)
      this.showSnackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'

    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.saveErrorMessage').toString()
    } finally {
      this.saveInProgress = false
    }
  }

  onCloseTimeBlockDialog () {
    this.addNewTimeBlockDialog = false
    this.selectedTimeBlock = null
  }

  onDraggableChange (): void{
    this.filteredTimeBlock = this.filteredTimeBlock!.map((i: BusinessTimeBlockCollection, idx: number) => {
      return i.updateOrder(idx + 1)
    })
    this.filteredTimeBlock?.forEach((item: BusinessTimeBlockCollection)=> {

      let payload: UpdateTimeBlockPayload = {
        id: item!.id,
        title: item.title,
        business: item.business.id,
        order: item.order,
        reservationDeadline: item.reservationDeadline ? item.reservationDeadline : null,
        deadlineForPreviousDay: item.deadlineForPreviousDay
      }
      this.updateTimeBlock(payload)
    })
  }

  addNewTimeBlock () {
    this.addNewTimeBlockDialog = true
  }

  async fetchData (): Promise<void> {
    const payload: any = this.businessToEdit.id
    try {
      this.timeBlockCollection = await this.fetchTimeBlockCollection(payload)

    }catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
  }

  async saveBusiness(): Promise<void> {
    this.saveInProgress = true
    if (!this.businessToEdit) {
      let payload: AddNewBusinessPayload = {
        name: this.businessName
      }
      try {
        await this.saveNewBusiness(payload)
        this.businessAction = "added"
        this.closeDialog(this.businessAction)
      } catch (e) {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('errors.saveErrorMessage').toString()
      }
    } else {
      let payload: UpdateBusinessPayload = {
        id: this.businessToEdit.id,
        name: this.businessName
      }
      try {
        await this.updateBusiness(payload)
        this.businessAction = "edited"
        this.closeDialog(this.businessAction)
      } catch (e) {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('errors.saveErrorMessage').toString()
      }
    }
    this.saveInProgress = false
  }

  onCloseButtonClick(): void {
    this.closeDialog()
  }

  closeDialog(businessAction?: string): void {
    this.$emit("closeBusinessDialog", businessAction)
  }

  mounted(): void {
    if (this.businessToEdit) {
      this.businessName = this.businessToEdit.name
      this.fetchData()
    }
  }
}
</script>

<style lang="stylus" scoped>

.v-tabs {
  max-height 48px
}

.listItem {
  cursor pointer
}

.dragStyle {
  cursor move
}
</style>